import { gql } from "@apollo/client";

// The one `KeyFragment` in this app, shared by all three key sections —
// queries/key (the account's own), queries/domain-key and
// queries/organization-key. graphql-tag holds fragment names app-wide, so the
// three copies this replaces made it warn on every page, and which body a
// document got depended on import order (two of them had no `description`).
//
// `scope` and `rateLimit` are what tell an agent key from an organization-wide
// one — docs/scoped-keys.md, and §The auth app for how the screens show them.
// Both are null on an organization-wide key. The account section reaches the
// API through a self-call, whose @repoflow/auth-api fragment decides what comes
// back: `scope` needs auth-api 1.4.0 or later, and `rateLimit` is not selected
// by any release, so that section shows the default limits (P281).
//
// No keySecret. The API stores a bcrypt hash and only returns a usable value
// from create, so asking for it on a read selects a field that is always null
// and advertises an interest in a credential this app cannot use. Each
// `create` adds it back inline.
export const KeyFragment = gql`
  fragment KeyFragment on Key {
    id
    keyId
    description
    roles
    scope {
      service
      type
      id
    }
    rateLimit {
      minute
      day
    }

    createdAt
    updatedAt
  }
`;
